import { Control, useWatch } from "react-hook-form";

import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

import InputFormField from "components/input-form-field";
import SelectFormField from "components/select-form-field";
import { GENDER } from "constants/patients";

import { PatientFormValues } from "../patient-form.component";

type GenderFieldProps = {
  control: Control<PatientFormValues, object>;
  required?: boolean;
};

export default function GenderField({
  control,
  required = false
}: GenderFieldProps) {
  const gender = useWatch({ control, name: "gender" });

  return (
    <Box display="flex" justifyContent="space-between">
      <PersonOutlineOutlinedIcon sx={{ mt: "30px", mr: 1.5 }} />
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <SelectFormField
            label="Gender"
            name="gender"
            control={control}
            options={GENDER.getOptions()}
            required={required}
          />
        </Grid>
        {gender === "NB" && (
          <Grid item xs={6}>
            <InputFormField
              label="Gender (Other)"
              name="gender_other"
              control={control}
              placeholder="Please specify your gender"
              sx={{}}
            />
          </Grid>
        )}
      </Grid>
    </Box>
  );
}
